import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { HiMenu, HiX } from 'react-icons/hi';
import Logo from "../assets/tuber_logo.png";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  // Scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 120);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close drawer on link click
  const handleLinkClick = () => {
    setIsDrawerOpen(false);
  };

  return (
    <>
      <header
        className={`fixed w-full py-4 z-50 px-4 transition-all duration-300 ${isScrolled ? 'backdrop-blur-md' : ''}`}
      >
        <div className='max-w-7xl w-full m-auto flex justify-between items-center'>
          <Link to="/">
            <img src={Logo} alt="logo" loading='lazy' className='h-6 md:h-8' />
          </Link>

          {/* Desktop Buttons */}
          <div className="space-x-4 hidden md:flex">
            <Link to="/businesses" className="bg-primary rounded-md px-6 py-[10px] font-semibold text-white hover:opacity-90 transition-all duration-300">
              For Businesses
            </Link>

            <Link to="/drivers" className="bg-primary rounded-md px-6 py-[10px] font-semibold text-white hover:opacity-90 transition-all duration-300">
              For Drivers
            </Link>
          </div>

          {/* Mobile Menu Icon */}
          <div className="md:hidden">
            <button onClick={() => setIsDrawerOpen(true)}>
              <HiMenu className="text-3xl text-white" />
            </button>
          </div>
        </div>
      </header>

      {/* Drawer Overlay */}
      <div
        className={`fixed top-0 left-0 max-w-[250px] w-full h-full bg-white z-40 shadow-lg transform transition-transform duration-300 ${
          isDrawerOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex justify-between items-center p-4 border-b">
          <img src={Logo} alt="logo" className="h-6" />
          <button onClick={() => setIsDrawerOpen(false)}>
            <HiX className="text-2xl" />
          </button>
        </div>

        <div className="flex flex-col p-4 space-y-4">
          <Link to="#"
            className="bg-primary px-4 py-3 font-semibold text-white uppercase rounded hover:opacity-90"
            onClick={handleLinkClick}
          >
            For Businesses
          </Link>
          
          <Link to="/drivers"
            className="bg-primary px-4 py-3 font-semibold text-white uppercase rounded hover:opacity-90"
            onClick={handleLinkClick}
          >
            For Drivers
          </Link>
        </div>
      </div>

      {/* Optional Backdrop when drawer is open */}
      {isDrawerOpen && (
        <div
          className="fixed inset-0 bg-black/30 z-30"
          onClick={() => setIsDrawerOpen(false)}
        />
      )}
    </>
  );
};

export default Header;
